<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        <h2 > Use Cases of Smart Collect </h2>
                    </h2>
                </div>

                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  .
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='61'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/t4vkDWertB0?si=NX2r1nkNpN65kn0U" 
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id='62'>
                    <h4 >
                        Use Cases of Smart Collect
                    </h4>
                   
                    <label for="" class="mt-3" ><b>School Fee Collection:
                        </b>&nbsp;Simplify the
                        process of collecting tuition and fees from students and parents in
                        educational institutions. Implement an efficient school fee collection
                        system that allows for online payments, provides detailed invoices, and
                        ensures transparent record-keeping. This helps streamline administrative
                        tasks and ensures timely payments, contributing to the smooth functioning of
                        the school's financial operations. </label>

                    <label for="" class="mt-4" ><b> College Fee Collection:&nbsp;
                        </b>Streamline the
                        collection of college tuition fees and related charges for students. A
                        robust college fee collection system facilitates online payments, allows for
                        the creation of customized fee structures, and provides detailed financial
                        statements. This ensures that students and their families can manage
                        educational expenses conveniently, while colleges maintain accurate
                        financial records. </label>
                    <label for="" class="mt-4" ><b> Govt. Bills (Electricity
                            Bills):&nbsp;</b> This
                        includes generating and distributing electricity bills to customers,
                        offering multiple payment options such as online payments, and providing a
                        user-friendly interface for customers to track and manage their electricity
                        usage. An effective electricity billing system contributes to accurate
                        billing, timely payments, and improved customer satisfaction. </label>

                    <label for="" class="mt-4" ><b>Govt. Bills (Water Bills):
                            &nbsp;</b>Providing
                        customers with a clear breakdown of their water usage and bills helps
                        promote water conservation and ensures a transparent and efficient billing
                        process. </label>
                  
                </div>

                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id='63'>
                    <h2 >Create a Smart collect profile quickly and easily with these
                        seven steps:
                    </h2>
          

                    <label for="" class="mt-5" ><b>Step 1:&nbsp;</b> Sign up for a
                        PayG account. If
                        you already have an account, log in with your credentials. </label>
                    <label for="" class="mt-4" ><b>Step 2: &nbsp;</b>Navigate to the
                        Pay Profile
                        section and create a new profile.  </label>
                    <label for="" class="mt-4" ><b>Step 3: &nbsp;</b>Fill in the
                        business details.  
                    </label>
                    <label for="" class="mt-4" ><b>Step 4: &nbsp;</b>Create fields
                        for your customers
                        and then add data to them  </label>
                    <label for="" class="mt-4" ><b>Step 5: &nbsp;</b>Configure the
                        Payment Receipt
                        settings.    </label>
                    <label for="" class="mt-4" ><b>Step 6: &nbsp;</b> Adjust the Pay
                        Profile
                        configuration.    </label>
                    <label for="" class="mt-4" ><b>Step 7 : &nbsp;</b>Share your
                        profile with your
                        customers and begin accepting payments.   </label>
                   

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id='63'>
                    <label for="" class="mt-3" >
                        Sign in to your account
                    </label>
                 
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/booking1.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3" >
                        Navigate to the Pay Profile section on the dashboard.
                    </label>
              
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/A screenshot1.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3" >
                        Click on "Create New Pay Profile" .
                    </label>
              
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3" >
                        Select “Smart Collect”.
                    </label>
                 
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/A screenshot2.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3" >
                        Choose a template as per your requirements.
                    </label>
             
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/A screenshot3.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-3" >
                        Choose a colour theme in line with your branding. Provide a title for your
                        payment collection and include a description along with contact details
                        about your organization.
                    </label>
                
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (1).png" width="60%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-3" >
                        Create input fields for customers to enter and search their details using a
                        specified unique field. Additionally, include output fields for relevant
                        information.
                    </label>
                 
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (2).png" width="60%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3" >


                        Add an amount field to specify how you want to collect payment from your
                        customers. And if you want to add security to the data, you can add your
                        customer’s mobile number in that filed.
                    </label>
               
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (3).png" width="60%" alt="">
                        </div>
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (4).png" width="60%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3" >


                        Add data to the fields you created in earlier step. You can add data
                        manually one by one or you can upload a csv file to add the entire data of
                        all your customers.
                    </label>
                  
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (5).png" width="60%" alt="">
                        </div>
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (6).png" width="60%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3" >



                        The next step is “Payment Receipt Settings”. Select as per your requirement
                        and move to the next step. 
                    </label>
                   
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (7).png" width="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-3" >


                        In the "Pay Profile Settings" section, you have options to set up a custom
                        URL. You can personalize the URL or opt for a randomly generated one by
                        selecting "Create a random URL". Additionally, you can enable partial
                        payment for your customers. Set the date and time for when your profile
                        should become active. You have the choice to include a button for your
                        profile and a QR code. Pick your preferences and then click the "Next"
                        button to create your profile.   
                    </label>
                    
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (8).png" width="100%" alt="">
                        </div>
                    </div>


                    <label for="" class="mt-3" >
                        You can copy the link and download the QR code to send it to your customers.
                        Additionally, you can share it with your customers on their mobile numbers
                        or email
                    </label>
               
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/image (9).png" width="60%" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5 >
                        Table of Contents:
                    </h5>
                
                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#61">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                   
How to Use Cases 
</span>
                            </div>
                        </div>
                    </a> -->
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#62">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >

                                    Use Cases of Smart Collect
                                </span>
                             
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#63">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    >

                                    How to create a Smart Collect Pay Profile?
                                </span>
                           
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="https://payg.in/customer/#/pay-profile/MTczMzkxODEyOTMzNTky" target="_blank">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover2" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">
                                    Demo Profile for Fee Collection</span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-2">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/Pay Profile Smart Collect.pdf"
                                target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='5'}"
                                    (click)="color('5')">
                                    Smart Collect </span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/Pay Profile Smart Collect.pdf" download><img src="./assets/Download.svg"
                                    alt="" width="100%"></a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/easy-collect']">      <button class="btn btn-color" (click)="menues('Easy Collect')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Easy Collect
                </button></a>
                
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/booking-tecketing']">  <button class="btn btn-color" (click)="menues('Booking & Ticketing')"
                    >Booking
                    & Ticketing
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
             
            </div>

        </div>
    </div>
    </div>